import React, { Fragment } from "react";
import PlacesAutocomplete, {
  geocodeByAddress,
  getLatLng,
} from "react-places-autocomplete";

export const AutocompletePlace = (props) => {
  const { error, label, requiredLabel = false } = props;
  const searchoptions = {
    types: ["(regions)"],
    componentRestrictions: { country: "in" },
  };
  return (
    <Fragment>
      <label>
        {label}
        {requiredLabel && <span className="required-field"></span>}
      </label>
      <PlacesAutocomplete
        value={props.value || ""}
        onChange={props.onChange}
        searchOptions={searchoptions}
        onSelect={(val) =>
          geocodeByAddress(val)
            .then((results) => getLatLng(results[0]))
            .then((latLng) => props.onSelect(latLng, val))
            .catch((error) => console.error("Error", error))
        }
      >
        {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
          <div>
            <input
              {...getInputProps({
                placeholder: props.placeholder,
                className: "form-control dropdown",
              })}
            />
            <div className="dropdown-content">
              {loading && <div>Loading...</div>}
              {suggestions.map((suggestion) => {
                const className = suggestion.active
                  ? "form-control suggestion-item--active"
                  : "form-control suggestion-item";
                // inline style for demonstration purpose
                const style = suggestion.active
                  ? {
                      backgroundColor: "#fafafa",
                      cursor: "pointer",
                    }
                  : {
                      backgroundColor: "#ffffff",
                      cursor: "pointer",
                    };
                return (
                  <div
                    {...getSuggestionItemProps(suggestion, {
                      className,
                      style,
                    })}
                  >
                    <span>{suggestion.description}</span>
                  </div>
                );
              })}
            </div>
          </div>
        )}
      </PlacesAutocomplete>
      {error && <span style={{ color: "red" }}>{error}</span>}
    </Fragment>
  );
};
